import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { V2AdminService } from "../../../services/api/v2-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { MpCommonActions } from "../../actions/mp-common.actions";

@Injectable()
export class VendorStatusEffects {
	disableVendor = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.vendor.disable),
			mergeMap((action) =>
				this.adminService.disableVendor(action.id, action.accountStatusRemarks).pipe(
					map(() => MpAdminActions.vendor.disableSuccess({ id: action.id })),
					catchError((error) =>
						of(MpAdminActions.vendor.disableFail(new FailState(error)))
					)
				)
			)
		)
	);

	enableVendor = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.vendor.enable),
			mergeMap((action) =>
				this.adminService.enableVendor(action.id, action.accountStatusRemarks).pipe(
					map(() => MpAdminActions.vendor.enableSuccess({ id: action.id })),
					catchError((error) =>
						of(MpAdminActions.vendor.enableFail(new FailState(error)))
					)
				)
			)
		)
	);

	enableVendorSuccess = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.vendor.enableSuccess),
			map((action) => {
				return MpCommonActions.activeVendors.getApi({ params: { id: action.id } });
			})
		)
	);

	constructor(
		private actions$: Actions,
		private adminService: V2AdminService
	) {}
}
